// extracted by mini-css-extract-plugin
export default {"suggestionBlock":"suggestions_suggestionBlock__c-u+6","suggestions":"suggestions_suggestions__Q-mIF"};